module.exports = "<app-workflow-navi-bar></app-workflow-navi-bar>\n\n<br>\n  <router-outlet></router-outlet>\n<br>\n"